import React, { Component } from 'react';

import Header from '../Header';
import SidebarIndex from './SidebarIndex';
import IntroductionItems from './instructions';
import CustomCard from '../CustomCard';
import CardHeader from '../CustomCard/CardHeader';
import CardBody from '../CustomCard/CardBody';
import CustomButton from '../Button/CustomButton';
import AppRoutes from '../../config/AppRoutes';
import { getTokenAndEmail, generateTestId } from '../services';
import { renderHTMLContent } from '../../../common/function';
export default class Instructions extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  startTest = async () => {
    const { id, timer } = this.props.params;

    const result = await generateTestId({
      ...getTokenAndEmail(),
      mock_id: id ? parseInt(id, 10) : null,
      status: 'pending',
    });

    if (result.success) {
      this.context.router.push({
        pathname: AppRoutes.ESG_CBT_QUESTIONS.replace(':mockId', id)
          .replace(':timer', timer)
          .replace(':timerStart', true)
          .replace(':isNegative', false)
          .replace(':offset', 0)
          .replace(':testId', result.id),
      });
    }
  };

  changePageByIndex = (index) => {
    if (isNaN(index)) index = 0;
    const { timer, id } = this.props.params;
    this.context.router.push({
      pathname: AppRoutes.ESG_CBT_INTRODUCTION.replace(':id', id)
        .replace(':timer', timer)
        .replace(':offset', index),
    });
  };

  onClickPreviousButton = (offset) => {
    this.changePageByIndex(offset - 1);
  };
  onClickNextButton = (offset) => {
    this.changePageByIndex(parseInt(offset, 10) + 1);
  };

  render() {
    const { offset } = this.props.params;
    try {
      const { title, content, buttonText } = IntroductionItems[offset];
      return (
        <div className='animated fadeIn'>
          <Header title='Section Introduction' />
          <div className='d-flex font-16px'>
            <SidebarIndex
              itemArray={IntroductionItems}
              currentIndex={offset}
              onClick={(index) => this.changePageByIndex(index)}
              sliderSetting={{ arrows: false }}
            />
            <CustomCard className='w-100'>
              <CardHeader headingText={title} />
              <CardBody>
                {content.map((item) => {
                  return item.image ? (
                    <p>
                      <img src={item.image} alt={item.image} />
                    </p>
                  ) : (
                    renderHTMLContent(item.html, 'div', 'font-16px')
                  );
                })}

                {buttonText && <h6 className='mt-3'>{buttonText}</h6>}
              </CardBody>
              <CardBody className='text-right btm-btn-wrapper'>
                <CustomButton
                  onClick={() => this.onClickPreviousButton(offset)}
                  disabled={0 === parseInt(offset, 10)}
                >
                  <i className='fa fa-angle-left' /> <span>Back</span>
                </CustomButton>
                <CustomButton
                  onClick={() => this.onClickNextButton(offset)}
                  disabled={IntroductionItems.length - 1 === parseInt(offset, 10)}
                >
                  <span>Next</span> <i className='fa fa-angle-right' />
                </CustomButton>
                <CustomButton onClick={this.startTest}>Start Test</CustomButton>
              </CardBody>
            </CustomCard>
          </div>
        </div>
      );
    } catch (error) {
      console.trace(error);
      return <div>{error.message} </div>;
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/ESG/CBT/Instructions.jsx